import { CardAction } from './CardAction/CardAction';
import { CardContent } from './CardContent/CardContent';
import { CardHeader } from './CardHeader/CardHeader';
import { CardRoot } from './CardRoot/CardRoot';
import { CardTitle } from './CardTitle/CardTitle';

export const Card = {
  Root: CardRoot,
  Header: CardHeader,
  Content: CardContent,
  Title: CardTitle,
  Action: CardAction,
};
